import api from "@/plugins/axios";
import Contact from "@/models/contact";
import { Meta, QueryParams } from "@/models/general";

const ContactAPI = {
  async newContact(payload: Contact): Promise<Contact | undefined> {
    return api.post(`/companies/${payload.company_id}/contacts`, payload);
  },
  async getContacts(
    params: QueryParams,
    company_id?: string
  ): Promise<{ data: Contact[]; meta: Meta }> {
    const endpoint = company_id
      ? `/companies/${company_id}/contacts`
      : "/contacts";
    return api.get(endpoint, { params: params });
  },
  async getContact(id: string, company_id: string): Promise<Contact> {
    return api.get(`/companies/${company_id}/contacts/${id}`);
  },
  async updateContact(payload: Contact): Promise<Contact | undefined> {
    return api.put(
      `/companies/${payload.company_id}/contacts/${payload.id}`,
      payload
    );
  },
  async deleteContact(id: string, company_id: string): Promise<void> {
    return api.delete(`/companies/${company_id}/contacts/${id}`);
  },
};

export default ContactAPI;
